import {StringUtils} from '../string.utils';
export class ApiCall {
  url: string;
  path: string;
  method: string;
  application: string;
  body: string;
  reqParameters: string;

  constructor(path: string, method: string, body?: string) {
    this.path = path;
    this.method = method;
    if (!StringUtils.isEmpty(body)) {
      this.body = body;
    }
  }

  public static getter(app: string, path: any, ): ApiCall {
    const apiCall: ApiCall = new ApiCall(path, 'get');
    apiCall.method = 'get';
    apiCall.path = path;
    apiCall.application = app;
    return apiCall;
  }

  public static postjson(app: string, path: any, obj: any): ApiCall {
    const apiCall: ApiCall = new ApiCall(path, 'post');
    apiCall.method = 'post';
    apiCall.application = app;
    apiCall.url = path;
    apiCall.body = obj;
    return apiCall;
  }

}
